// Notification's type emitted by the BE (NotificationTypes.cs)
export enum NotificationType {
    OfficerReportGenerated = 'OFFICER_REPORT_GENERATED'
}
